import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";

export const TwoCol = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: ${spacing[3]};
  align-items: stretch;
  width: 100%;

  @media (max-width: 480px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const EveryRow = styled.div`
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  gap: ${spacing[3]};
  align-items: stretch;
  width: 100%;
`;

export const DayRow = styled.div`
 width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${spacing[2]};
  flex-wrap: wrap;
`;

export const HelperText = styled.span<{ $error: boolean }>`
  ${typographyMixin("caption", 4)}
  color: ${({ $error }) =>
    $error ? rawColors.accent.pink : rawColors.text.mediumEmphasis};
`;
